const Join = {
    setColorClass(target, color) {
        const colors = ["red", "blue", "black", "green"];
        target.classList.remove(...colors);
        target.classList.add(color);
    },
};

export { Join };